export default __webpack_public_path__ + "static/logo_sqex_dark-846ecccb-3a2af588f1e522071b2314e25ca22c4e.png";